import React from "react";
import ModalAprobar from "./ModalAprobar";
import ModalRechazar from "./ModalRechazar";

const modalAR = ({ type, quoteData, numCotizacion, moneda }: any) => {
  return (
    <div>
        {
          (type === 'Aprobar') ? <ModalAprobar numCotizacion={numCotizacion} /> : <ModalRechazar product={quoteData.producto.codigo} moneda={moneda} />
        }
    </div>
  );
};

export default modalAR;
